import React, { useState, useEffect } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, NumberInput, Button, Group, Title, Text, Stack, Slider } from '@mantine/core';
import { saveLevel, updateLevel } from '../../services/api.service';
import { IconCheck } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';

const LevelForm = ({ closeModal, isEdit, level }) => {

	// Hooks
	const [isLoading, toggleLoading] = useState(false);
	const form = useForm({
		initialValues: {
			name: '',
			points: 0,
			pointsPerMeter: 0,
		},
	});

	// Check if edit
	useEffect(() => {
		if (isEdit) form.setValues({
			name: level.name,
			points: level.points,
			pointsPerMeter: level.pointsPerMeter,
		});
		// eslint-disable-next-line
	}, []);

	// Submit form
	const onSubmit = (values) => {

		// Set loader
		toggleLoading(true);

		// Conditions
		if (!isEdit) {

			// Call API
			saveLevel(values, function () {

				// Show success
				notifications.show({
					title: 'Nivel creado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		} else {

			// Call API
			updateLevel(level.id, values, function () {

				// Show success
				notifications.show({
					title: 'Nivel modificado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		}

	}

	return (
		<>
			{/* Form */}
			<form onSubmit={form.onSubmit(onSubmit)}>
				{/* Title */}
				<Title
					order={5}
					mb="md"
				>
					{isEdit ? 'Modificar' : ''} Información de Nivel
				</Title>
				{/* Input Group */}
				<Group grow>
					{/* Name */}
					<TextInput
						required
						label="Nombre"
						placeholder="Nombre del nivel"
						value={form.values.name}
						onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
						{...form.getInputProps('name')}
					/>
					{/* Points */}
					<NumberInput
						defaultValue={50}
						placeholder="0-10"
						label="Puntos"
						required
						min={1}
						value={form.values.points}
						onChange={(event) => form.setFieldValue('points', event.currentTarget.value)}
						{...form.getInputProps('points')}
					/>
				</Group>
				{/* Input Group */}
				<Group
					grow
					mt="md"
				>
					{/* Points Per Meter */}
					<Stack>
						{/* Label */}
						<Text
							size="sm"
							color="#C1C2C5"
							fw={500}
						>
							Puntos por metro: {form.values.pointsPerMeter}
						</Text>
						{/* Points */}
						<Slider
							marks={[
								{ value: 10 },
								{ value: 20 },
								{ value: 30 },
								{ value: 40 },
								{ value: 50 },
								{ value: 60 },
								{ value: 70 },
								{ value: 80 },
								{ value: 90 },
								{ value: 100 },
							]}
							value={form.values.pointsPerMeter}
							onChange={(event) => form.setFieldValue('pointsPerMeter', event.currentTarget.value)}
							{...form.getInputProps('pointsPerMeter')}
							min={0}
							max={100}
							step={1}
							precision={1}
						/>
					</Stack>
				</Group>
				{/* Buttons */}
				<Group
					position="apart"
					grow={!isEdit}
				>
					{/* Cancel */}
					<Button
						mt="xl"
						color="red"
						onClick={closeModal}
						disabled={isLoading}
						variant="light"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						Cancelar
					</Button>
					{/* Submit */}
					<Button
						mt="xl"
						type="submit"
						loading={isLoading}
						variant="filled"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						{isEdit ? 'Guardar Cambios' : 'Crear Nivel'}
					</Button>
				</Group>
			</form>
		</>
	);

}

export default LevelForm;
